// redux-persist transforms.
import { createTransform } from 'redux-persist';

interface OrgLike {
  profile?: {
    avatar?: { url?: string | null; [k: string]: unknown } | null;
    [k: string]: unknown;
  } | null;
  [k: string]: unknown;
}

/**
 * The org avatar `url` is a short-lived **signed CloudFront link** the GraphQL
 * resolver mints per request — it must never live in persisted storage. A
 * persisted URL expires and then 403s (the AccountMenu bug, #81); keeping it at
 * rest is the root smell (#83). Strip just the volatile `url` (s3Key and the
 * rest of the avatar metadata stay) on the way INTO storage; the boot re-sync
 * in `accountDataLoadSaga` repopulates a fresh signed URL from the account
 * fetch, so consumers never read a stale one.
 */
const stripSignedAvatarUrl = (org: OrgLike | null): OrgLike | null => {
  if (!org?.profile?.avatar?.url) return org;
  return {
    ...org,
    profile: {
      ...org.profile,
      avatar: { ...org.profile.avatar, url: null },
    },
  };
};

/**
 * Applied to the `SelectedOrganization` slice only. Inbound (state → storage)
 * strips the signed avatar URL; outbound (storage → state) passes through —
 * the value is already absent at rest.
 */
export const selectedOrganizationTransform = createTransform(
  (inboundState) => stripSignedAvatarUrl(inboundState as OrgLike | null),
  (outboundState) => outboundState,
  { whitelist: ['SelectedOrganization'] },
);
